import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';

import { getMainPlayerWidget } from '../../../common/components/Player/helpers';
import { getLinks, getMentions, getText } from '../../../common/helpers/comments';
import { gqlRequest } from '../../../common/helpers/request';
import {
  createCommentAction,
  createCommentFinishedAction,
  getCommentsAndSummaryAction,
  setSelectedCommentIdAction,
} from '../slices/comments';

const queryGQL = `
  mutation hostedWatchCreateComment(
      $videoId: String,
      $params: HostedWatchCreateCommentInput,
  ) {
    hostedWatchCreateComment(
      videoId: $videoId,
      params: $params,
    ) {
        activeChildCount,
        deletedChildCount,
        time,
        id,
        index,
        parentId,
        status,
        created,
        html,
        author {
          id,
          firstName,
          lastName,
        }
    }
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(createCommentAction.type),
    mergeMap(({ payload }) =>
      gqlRequest({
        query: queryGQL,
        variables: {
          videoId: payload.videoId,
          params: {
            time: payload.time,
            parentId: payload.parentId ?? undefined,
            body: payload.body,
            html: payload.html,
            mentions: payload.mentions,
            urlComment: payload.urlComment,
            urlVideo: payload.urlVideo,
          },
        },
      }).pipe(
        switchMap(({ data, errors }) => {
          const actions = [];

          if (errors.length) {
            const getCommentsInfoPayload = {
              videoId: payload.videoId,
              videoTime: {
                from: 0,
              },
              from: 0, // portion start
              size: 10000,
            };

            actions.push(of(setSelectedCommentIdAction(null)), of(getCommentsAndSummaryAction(getCommentsInfoPayload)));
          } else {
            const { index, id } = data.hostedWatchCreateComment;
            const LWP = getMainPlayerWidget();

            LWP.sendStatsAddComment(
              payload.parentId ? 2 : 1,
              index,
              getText(payload.html).length,
              !!getMentions(payload.html).length,
              !!getLinks(payload.html).length,
            );
            actions.push(
              of(
                createCommentFinishedAction({
                  targetReplaceId: payload.targetReplaceId,
                  comment: data.hostedWatchCreateComment,
                }),
              ),
              of(setSelectedCommentIdAction(id)),
            );
          }

          return concat(...actions);
        }),
      ),
    ),
  );
